"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// TODO: breakout priority enum to be more flexible
var AvatarPriorityEnum;
(function (AvatarPriorityEnum) {
    AvatarPriorityEnum["DEFAULT"] = "default";
    AvatarPriorityEnum["PRIMARY"] = "primary";
    AvatarPriorityEnum["SECONDARY"] = "secondary";
    AvatarPriorityEnum["VEHICLE"] = "vehicle";
    AvatarPriorityEnum["CELEBRATE"] = "celebrate";
})(AvatarPriorityEnum || (AvatarPriorityEnum = {}));
exports.default = AvatarPriorityEnum;
